module.exports = __webpack_public_path__ + "font_hui_daughter.ed395a48.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/child_to_parent/font_hui_daughter.png
// module id = 08gO
// module chunks = 0